import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./deliveryCities.css";
import img1 from "../../../assets/images/gurugram.png";
import img2 from "../../../assets/images/banglore.png";
import { TextField, InputAdornment, checkboxClasses } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import location from "../../../assets/images/location.png";
import { CircularProgress } from "@mui/material";

import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useSelector } from "react-redux";
import DeliveryModal from "./DeliveryModal";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeliveryCities = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const data = useSelector((store) => store.data.HomeData);
  const [cardData, setCardData] = useState({});
  const [showSearch, setShowSearch] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showModal, setShowModal] = useState(false);
  const [Pincodeflag, setPincodeFlag] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [error, setError] = useState("");
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setPinCode(e.target.value);
    setError("");
  };
  const handleCancel = (e) => {
    e.stopPropagation();
    setShowSearch(false);
  };

  useEffect(() => {
    data?.items.forEach((ele) => {
      if (ele.Section == "ServingLocation") {
        setCardData(ele.Content);
      }
    });
  }, [data]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const checkDeliveryAvailability = async (pinCode) => {
    setIsLoading(true);
    try {
      const response = await fetch(baseURL + "/serviceable-zipcode-website", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Zipcode: pinCode }),
      });

      const result = await response.json();

      if (response.ok) {
        setShowDeliveryModal(true);
        setPincodeFlag("Yes");
      } else {
        // console.log(response);
        setShowDeliveryModal(true);
        setPincodeFlag("No");
      }
    } catch (error) {
      console.error("Network Error:", error);
      // Optionally show fallback UI or error message
    } finally {
      setIsLoading(false); // Stop loader
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (!/^\d{6}$/.test(pinCode)) {
      setError("Please enter a valid 6-digit PIN code");
    } else {
      setError("");
      // console.log("Valid PIN:", pinCode);
      // setShowDeliveryModal(true);
      checkDeliveryAvailability(pinCode);
    }
  };

  return (
    <div className="delivery-city-wrapper">
      <div className="main-delivery-container">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="heading1 capitalize-first-letter"
        >
          Still relying on snail-speed logistics? time to ditch the drama and fly into the future with Skye Air’s drone delivery!
        </motion.h2>

        <div className="cards-container1 row">
          {cardData?.ServingCities?.map((card, index) => (
            <motion.div
              key={index}
              className="card col-md-2 mb-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              style={{
                backgroundImage: `linear-gradient(rgb(0 0 0 / 0%), rgb(16 16 16 / 70%)), url(${card.ImageURL})`,
              }}
            >
              <div>
                <h3 className="mt-3 fw-bold card-heading">{card.CityName}</h3>
              </div>
            </motion.div>
          ))}
        </div>

        {windowWidth >= 480 ? (
          <div
            className={`location-search ${showSearch ? "expanded" : ""}`}
            onClick={() => setShowSearch(true)}
          >
            {showSearch ? (
              <div className="search-box">
                <h2 className="mb-5 search-heading capitalize-first-letter">
                  Enter your PIN code to check if Skye Air’s next-gen drone delivery is flying to your neighborhood!
                </h2>
                <TextField
                  fullWidth
                  placeholder="Enter your pin code"
                  variant="outlined"
                  value={pinCode}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  error={!!error}
                  helperText={error || " "}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                          <button
                            className={`search-btn ${pinCode === '' ? 'disabled' : ''}`}
                            disabled={pinCode === ''}
                            onClick={handleSearch}
                          >
                            Search
                          </button>
                        </InputAdornment>
                    ),
                    style: { backgroundColor: "#fff" },
                  }}
                  sx={{
                    input: { color: "#000" },
                    backgroundColor: "#fff",
                    borderRadius: 1,
                  }}
                  className="search-input"
                />
            

                <button
                  className="cancel-btn text-center mt-5"
                  onClick={handleCancel}
                >
                  <CloseIcon /> Cancel
                </button>
                {isLoading && (
                  <div className="text-center mt-3">
                    <CircularProgress color="primary" size={24} />
                  </div>
                )}
              </div>
            ) : (
              <div>
                <img src={location} height={50} />
                <br />
                <br />
                <span className="find-location">Find My Location</span>
              </div>
            )}
          </div>
        ) : (
          <>
            <button className="btn find-btn w-100" onClick={handleClickOpen}>
              <img src={location} height={25} className="me-2" /> Find My
              Location
            </button>
            {windowWidth < 480 && (
              <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
              >
                <div>
                  <div className="search-box-mobile">
                    <h2 className="mb-5 search-heading capitalize-first-letter">
                    Enter your PIN code to check if Skye Air’s next-gen drone delivery is flying to your neighborhood!
                    </h2>
                    <TextField
                      fullWidth
                      placeholder="Enter your pin code"
                      variant="outlined"
                      value={pinCode}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      error={!!error}
                      helperText={error || " "}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <button className="search-btn" disabled={pinCode === ''} onClick={handleSearch}>
                                    Search
                                </button>
                            </InputAdornment>
                        ),
                        style: { backgroundColor: "#fff" },
                      }}
                      sx={{
                        input: { color: "#000" },
                        backgroundColor: "#fff",
                        borderRadius: 1,
                      }}
                      className="search-input"
                      type="number"
                    />
                

                    <button
                      className="cancel-btn text-center mt-3"
                      onClick={handleClose}
                    >
                      <CloseIcon /> Cancel
                    </button>
                    {isLoading && (
                      <div className="text-center mt-3">
                        <CircularProgress color="primary" size={24} />
                      </div>
                    )}
                  </div>
                </div>
              </Dialog>
            )}
          </>
        )}

        <DeliveryModal
          open={showDeliveryModal}
          handleClose={() => setShowDeliveryModal(false)}
          Pincodeflag={Pincodeflag}
        />
      </div>
    </div>
  );
};

export default DeliveryCities;
